import { useEffect, useState } from 'react';
import {
  convertRouteList,
  getDryRunRouteSegments,
  getFilteredRouteLegs,
  getRouteSegments,
} from '@lp/features/RoutePlanner/utils';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { AviaLegTypes, GroundLegTypes, HubRouteLocation, RouteTypeEnum } from '@/api/apis/route';
import { CaseFacility } from '@/api/apis/case';
import { RouteFilterType, RouteSegmentType } from '@/types/route';
import { CaseLogisticsSegment } from './CaseLogisticsSegment';

type CaseLogisticsRouteListProps = {
  filterType: RouteFilterType;
  type: RouteTypeEnum;
  donorHospital: CaseFacility;
  txCenter?: CaseFacility;
  donorHospitalDateTimeString?: string | null;
  recipientHospitalDateTimeString?: string | null;
  isRouteDone: boolean;
};

export const CaseLogisticsRouteList = ({
  filterType,
  type,
  donorHospital,
  txCenter,
  donorHospitalDateTimeString,
  recipientHospitalDateTimeString,
  isRouteDone,
}: CaseLogisticsRouteListProps) => {
  const [segments, setSegments] = useState<RouteSegmentType[]>([]);
  const [routeLegs, setRouteLegs] = useState<Map<string, (AviaLegTypes | GroundLegTypes)[]>>(new Map());
  const { legs, arrivalHub, departureHub } = useRouteDetails(type);
  const { getLocationById } = useRouteLocations();

  useEffect(() => {
    if (isRouteDone) {
      const filteredLegs = getFilteredRouteLegs(legs, filterType);
      const defaultSegments =
        type === RouteTypeEnum.Main
          ? getRouteSegments({
              arrivalHub: getLocationById(arrivalHub?.locationId) as HubRouteLocation,
              departureHub: getLocationById(departureHub?.locationId) as HubRouteLocation,
              donorHospital,
              txCenter,
              legs: filteredLegs,
              donorHospitalDateTimeString,
              recipientHospitalDateTimeString,
            })
          : getDryRunRouteSegments({
              arrivalHub: getLocationById(arrivalHub?.locationId) as HubRouteLocation,
              donorHospital,
              legs: filteredLegs,
            });

      const { segments: currentSegments, legs: currentLegs } = convertRouteList(
        defaultSegments,
        filteredLegs,
        filterType,
      );
      setSegments(currentSegments);
      setRouteLegs(currentLegs);
    }
  }, [
    isRouteDone,
    type,
    donorHospital,
    txCenter,
    recipientHospitalDateTimeString,
    donorHospitalDateTimeString,
    filterType,
    legs,
    getLocationById,
    arrivalHub?.locationId,
    departureHub?.locationId,
  ]);

  return (
    <div className="flex flex-col gap-5 pb-2 overflow-x-hidden">
      {segments.map((segment) => {
        return <CaseLogisticsSegment key={segment.id} segment={segment} routeLegs={routeLegs} />;
      })}
    </div>
  );
};
